import { debug } from "webpack";

const initFilter = () => {

    var hfeild1 = $('#hfildstartprice');
    var hfeild2 = $('#hfildendprice');
    var hfeild3 = $('#hfildstartset');
    var hfeild4 = $('#hfildendset');

    $(document).ready(function () {
        //Show more category btn
        if (!($('.Category--level0').height() < 180)) {
            $('#LoadMoreCategory').show();
        }
        //Set the filter wrapper on initiation

        var categoryHeight = $('.ListCategories').outerHeight();
        var winHeight = $(window).innerHeight();
        var winWidth = $(window).innerWidth();
        var filterMaxHeight = winHeight - (categoryHeight + 360)
        if (winWidth > 992) {
            $('.filter-wrapper').css('max-height', filterMaxHeight);
        }
        var filterCategory = $('.filter-category');
        filterCategory.each(function () {
            var selectedOptions = $(this).find('input:checked');
            var options = $(this).find('input');
            if (selectedOptions.length > 0) {
                var sortedFilter = $(this).find('.filter-name > div').toArray().sort(function (a, b) {
                    var $a = $(a).find(':checkbox'),
                        $b = $(b).find(':checkbox');
                    if ($a.is(':checked') && !$b.is(':checked'))
                        return -1;
                    else if (!$a.is(':checked') && $b.is(':checked'))
                        return 1;
                });
                for (const element of sortedFilter) {
                    $(this).find('.filter-name').append(element);
                }
                setTimeout(() => {
                    $(this).find('.filter-name').slideToggle();
                    $(this).removeClass('closed');
                    $(this).addClass('SemiClosed');
                    if (options.length > 5) {
                        $(this).find('.LoadMoreFilter').show();
                    }
                    if (selectedOptions.length > 5) {
                        $(this).removeClass('SemiClosed');
                        $(this).find('.LoadMoreFilter').text('کمتر');
                    }
                },500)
                
            }
        })
        var sideBar = document.getElementById('divSideBar');
        var filterBtn = document.getElementById('divFilterButton');
        if (sideBar) {
            filterBtn.style.display = "flex";
        }

        //Controlling the price slider change
        hfeild1.prop("disabled", true);
        hfeild2.prop("disabled", true);
        hfeild3.prop("disabled", true);
        hfeild4.prop("disabled", true);
    })

    //Controlling if price change
    $('.price-slider-container').click(() => {
        hfeild1.prop("disabled", false);
        hfeild2.prop("disabled", false);
        hfeild3.prop("disabled", false);
        hfeild4.prop("disabled", false);
    })


    $('.filter-category > div:first-of-type').click(function () {
        $(this).next().slideToggle();
        var options = $(this).next().find('input');
        if (options.length > 5) {
            if ($(this).closest('.filter-category').hasClass('closed')) {
                $(this).closest('.filter-category').addClass('SemiClosed');
                $(this).closest('.filter-category').removeClass('closed');
                $(this).closest('.filter-category').find('.LoadMoreFilter').show();
            } else if ($(this).closest('.filter-category').hasClass('SemiClosed')) {
                $(this).closest('.filter-category').removeClass('SemiClosed');
                $(this).closest('.filter-category').addClass('closed');
                $(this).closest('.filter-category').find('.LoadMoreFilter').hide();
            } else {
                $(this).next().hide();
                $(this).closest('.filter-category').addClass('closed');
            }
            var selectedOptions = $(this).next().find('input:checked');
            if (selectedOptions.length > 5) {
                $(this).closest('.filter-category').removeClass('SemiClosed');
            }
        }
    });
    //Load more filter
    $('.LoadMoreFilter').click(function () {
        $(this).closest('.filter-category').toggleClass('SemiClosed');
        $(this).toggle();
        //var text = $(this).find('span').text();
        //$(this).find('span').text(
        //    text == "بیشتر" ? "کمتر" : "بیشتر");
    })

    $('#btnProductFilter').click(e => {
        $('.transparent-fill').show();
        $('.list-sidebar').toggleClass('shown');
        $('body').css('overflow', 'hidden');
        e.preventDefault();
    });

    //Load more category
    $('#LoadMoreCategory').click((e) => {
        var span = $('#LoadMoreCategory').find('span');
        var text = span.text();
        $('#LoadMoreCategory').toggleClass('open')
        if (text == 'دسته‌بندی‌های بیشتر') {
            $('.Category--level0').css('max-height', 'unset');
            span.text('بستن دسته‌بندی')
        } else {
            $('.Category--level0').css('max-height', '180px');
            span.text('دسته‌بندی‌های بیشتر')
        }
    })

    //Category toggler for responsive
    $('.ListCategories > h2').click(() => {
        if ($(window).innerWidth() < 992) {
            $('.ListCategories > div').slideToggle();
            $('.ListCategories').toggleClass('closed');
            $('.Category--level0').css('max-height', '180px');
            if (!($('.Category--level0').height() < 180)) {
                $('#LoadMoreCategory').find('span').text('دسته‌بندی‌های بیشتر');
                $('#LoadMoreCategory').show();
                $('#LoadMoreCategory').removeClass('open')
            }
        } 
    })

};

export {
    initFilter
};
